import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ContractForm from "../../components/ContractForm";
import { actions } from "../../modules/contracts";
import { actions as itemsActions } from "../../modules/items";
import { actions as scootersActions } from "../../modules/scooters";
import { actions as customersActions } from "../../modules/customers";
import { actions as notesActions } from "../../modules/notes";
import { actions as discountActions } from "../../modules/discounts";
import { connect } from "react-redux";
import { withHandlers, compose, lifecycle, setDisplayName } from "recompose";
import JustForStaff from "../JustForStaff/index";
import { omit, isEmpty } from "lodash";

const propTypes = {
  failSubmitContract: PropTypes.string,
  submittingContract: PropTypes.bool.isRequired,
  onSubmit: PropTypes
};

const withHandleSubmit = withHandlers({
  onSubmit: ({
    currentDealer,
    currentCustomer,
    currentScooter,
    createContract,
    items,
    notes,
    discounts,
    history: { replace }
  }) => data => {
    data.customer_id = currentCustomer.id;
    data.scooter_id = currentScooter.id;
    data.items_attributes = items.map(item => ({
      ...omit(item, ["id"]),
      confirmed: !!data.pre_approved,
      required: !!data.pre_approved
    }));
    if (!isEmpty(notes))
      data.notes_attributes = notes.map(note => omit(note, ["id"]));
    if (!isEmpty(discounts))
      data.discounts_attributes = discounts.map(discount =>
        omit(discount, ["id"])
      );
    createContract({ dealer_id: currentDealer.id, data }).then(contract => {
      if (
        window.confirm(
          "Contract created successfully, do you want to create another one?"
        )
      ) {
        window.location.reload();
      } else {
        replace("/contracts");
      }
    });
  }
});

const withResetState = lifecycle({
  componentWillUnmount() {
    const {
      resetState,
      setCurrentCustomer,
      setCurrentScooter,
      setItems,
      setCurrentItem,
      setNotes,
      setCurrentNote,
      setCurrentDiscount,
      setDiscounts
    } = this.props;
    resetState();
    setCurrentCustomer(null);
    setCurrentScooter(null);
    setItems([]);
    setCurrentItem(null);
    setNotes([]);
    setCurrentNote(null);
    setDiscounts([]);
    setCurrentDiscount(null);
  }
});

const CreateContract = ({
  failSubmitContract,
  submittingContract,
  onSubmit,
  currentCustomer,
  currentScooter,
  items
}) => (
  <Fragment>
    <div className="row">
      <div className="col">
        <h3>
          <b>Create Contract</b>
        </h3>
      </div>
    </div>
    <ContractForm
      items={items}
      submittingContract={submittingContract}
      failSubmitContract={failSubmitContract}
      currentCustomer={currentCustomer}
      currentScooter={currentScooter}
      onSubmit={onSubmit}
    />
  </Fragment>
);

const mapStateToProps = state => ({
  ...(state.contracts || {}),
  currentDealer: state.dealers.currentDealer,
  currentCustomer: state.customers.currentCustomer,
  currentScooter: state.scooters.currentScooter,
  items: state.items.items,
  notes: state.notes.notes,
  discounts: state.discounts.discounts
});

const mapActionsToProps = {
  createContract: actions.createContract,
  setCurrentCustomer: customersActions.setCurrentCustomer,
  setCurrentScooter: scootersActions.setCurrentScooter,
  setItems: itemsActions.setItems,
  setCurrentItem: itemsActions.setCurrentItem,
  setNotes: notesActions.setNotes,
  setCurrentNote: notesActions.setCurrentNote,
  setDiscounts: discountActions.setDiscounts,
  setCurrentDiscount: discountActions.setCurrentDiscount,
  resetState: actions.resetState
};

CreateContract.propTypes = propTypes;

export default compose(
  setDisplayName("CreateContract"),
  JustForStaff,
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withResetState,
  withHandleSubmit
)(CreateContract);
